"use strict";

angular.module('app.hostnameMatchService', [])
  .factory('hostnameMatchService', [
    function () {
      let service = {
        hostname: function (hostname) {
          if (!hostname) {
            hostname = window.location.hostname;
          }

          if (hostname.match(/.*\.ahltv\.com/)) {
            return 'ahltv.com';
          }

          if (hostname.match(/.*\.watchtheahl\.com/)) {
            return 'watchtheahl.com';
          }

          if (hostname.match(/.*\.dev\.ahltv\.com/)) {
            return 'dev.ahltv.com';
          }

          if (hostname.match(/.*\.devbox\.ahltv\.com/)) {
            return 'devbox.ahltv.com';
          }

          if (hostname.match(/.*\.staging\.ahltv\.com/)) {
            return 'staging.ahltv.com';
          }

          if (hostname.match(/.*\.staging\.hockeytv\.aws\.htstack\.net/)) {
            return 'staging.hockeytv.aws.htstack.net';
          }

          if (hostname.match(/.*\.staging\.ahltv\.aws\.htstack\.net/)) {
            return 'staging.ahltv.aws.htstack.net';
          }

          if (hostname.match(/.*\.htv\.hockeytvdev\.com/)) {
            return 'htv.hockeytvdev.com';
          }

          if (hostname.match(/.*\.ahl\.hockeytvdev\.com/)) {
            return 'ahl.hockeytvdev.com';
          }

          if (hostname.match(/.*\.localhost\.hockeytv\.com/)) {
            return 'localhost.hockeytv.com';
          }

          if (hostname.match(/.*\.localhost\.ahltv\.com/)) {
            return 'localhost.ahltv.com';
          }

          if (hostname.match(/.*\.localhost/)) {
            return 'localhost';
          }

          if (hostname.match(/^192\.168\.\d+\.\d+/)) {
            return 'localhost';
          }

          if (hostname.match(/.*\.dev\.hockeytv\.com/)) {
            return 'dev.hockeytv.com';
          }

          if (hostname.match(/.*\.devbox\.hockeytv\.com/)) {
            return 'devbox.hockeytv.com';
          }

          if (hostname.match(/.*\.staging\.hockeytv\.com/)) {
            return 'staging.hockeytv.com';
          }

          if (hostname.match(/.*\.?hockeytv\.com/)) {
            return 'hockeytv.com';
          }

          return hostname;
        },
        domain: function (hostname) {
          return service.hostname(hostname);
        },
        base_url: function (subdomain, protocol) {
          let domain = service.domain();
          let port = '';

          if(!subdomain) subdomain = 'www';

          switch (domain) {
            case 'localhost':
              port = ':8080';
              break;
          }
          return (protocol ? protocol : window.location.protocol) + '//' + (subdomain ? subdomain + '.' : '') + domain + port;
        },
        is_api: function (hostname) {
          let el = document.createElement('a');
          el.href = hostname;
          hostname = el.hostname + ':' + el.port;
          switch (hostname) {
            case 'localhost:63342':
            case 'api.dev.hockeytv.com':
            case 'api.staging.hockeytv.com':
            case 'api.hockeytv.com':
              return true;
          }
          return false;
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/hostnameMatchService.js